import { z } from 'zod'

const ceilNumberSchema = z.number().transform((value) => Math.ceil(value))

export default ceilNumberSchema
